// Stock image mapping for articles
export const stockImages = {
  // University category
  'university': {
    'industrial-training': 'https://images.unsplash.com/photo-1513258496099-48168024aec0?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80', // Industrial workplace
    'academics': 'https://images.unsplash.com/photo-1523050854058-8df90110c9f1?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80', // University/study
    'default': 'https://images.unsplash.com/photo-1541339907198-e08756dedf3f?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80' // University building
  },
  
  // Setting up for success category
  'setting-up-for-success': {
    'pathway-to-success': 'https://images.unsplash.com/photo-1499781350541-7783f6c6a0c8?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80', // Pathway/steps to success
    'general-advice': 'https://images.unsplash.com/photo-1465101046530-73398c7f28ca?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80', // Success/growth
    'extracurricular-activities': 'https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80', // Team activities
    'networking': 'https://images.unsplash.com/photo-1559136555-9303baea8ebd?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80', // Networking/handshake
    'linkedin': 'https://images.unsplash.com/photo-1611224923853-80b023f02d71?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80', // Professional networking
    'default': 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80' // Professional growth
  },
  
  // Resume and cover letter category
  'resume-and-cover-letter': {
    'resume-crash-course': 'https://images.unsplash.com/photo-1586281380349-632531db7ed4?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80', // Resume/CV
    'resume-masterclass-content': 'https://images.unsplash.com/photo-1434030216411-0b793f4b4173?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80', // Writing/content
    'resume-masterclass-consolidation': 'https://images.unsplash.com/photo-1519389950473-47ba0277781c?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80', // Organization
    'resume-masterclass-formatting': 'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80', // Design/formatting
    'cover-letters': 'https://images.unsplash.com/photo-1521791136064-7986c2920216?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80', // Writing letters
    'default': 'https://images.unsplash.com/photo-1586281380349-632531db7ed4?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80' // Resume
  },
  
  // Job application process category
  'job-application-process': {
    'job-application-process': 'https://images.unsplash.com/photo-1556761175-5973dc0f32e7?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80', // Application process
    'helpful-resources-and-links': 'https://images.unsplash.com/photo-1498050108023-c5249f4df085?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80', // Digital resources
    'default': 'https://images.unsplash.com/photo-1450101499163-c8848c66ca85?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80' // Business application
  },
  
  // Interview preparation category
  'interview-preparation': {
    'online-assessments': 'https://images.unsplash.com/photo-1516321318423-f06f85e504b3?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80', // Online assessment
    'group-assessments': 'https://images.unsplash.com/photo-1552664730-d307ca884978?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80', // Group work
    'interview-masterclass-preparation': 'https://images.unsplash.com/photo-1515168833906-d2a3b82b302b?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80', // Preparation notes
    'interview-masterclass-answers': 'https://images.unsplash.com/photo-1515378791036-0648a3ef77b2?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80', // Answering questions
    'interview-masterclass-vibe': 'https://images.unsplash.com/photo-1521737852567-6949f3f9f2b5?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80', // Positive interview vibe
    'default': 'https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80' // Interview setting
  },
  
  // Career guidance category
  'career-guidance': {
    'career-progression': 'https://images.unsplash.com/photo-1503676382389-4809596d5290?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80', // Career ladder
    'career-options-and-disciplines': 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80', // Career paths
    'thinking-about-the-future': 'https://images.unsplash.com/photo-1516321318423-f06f85e504b3?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80', // Future planning
    'salary-expectations': 'https://images.unsplash.com/photo-1579532537598-459ecdaf39cc?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80', // Financial planning
    'default': 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80' // Career compass
  }
};

// Fallback image for any missing articles
export const defaultStockImage = 'https://images.unsplash.com/photo-1486312338219-ce68d2c6f44d?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80';

/**
 * Get the appropriate stock image for an article
 * @param {string} categoryKey - The category key
 * @param {string} articleId - The article ID
 * @returns {string} The image URL
 */
export const getArticleImage = (categoryKey, articleId) => {
  const categoryImages = stockImages[categoryKey];
  if (!categoryImages) return defaultStockImage;
  
  return categoryImages[articleId] || categoryImages.default || defaultStockImage;
};

/**
 * Get the default image for a category
 * @param {string} categoryKey - The category key
 * @returns {string} The image URL
 */
export const getCategoryImage = (categoryKey) => {
  const categoryImages = stockImages[categoryKey];
  return categoryImages?.default || defaultStockImage;
}; 